import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export class AlertingValidation {
  static beforeTodayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = new Date(control.value).setHours(0, 0, 0, 0);
      const today = new Date().setHours(0, 0, 0, 0);
      const beforeToday = date < today;

      return beforeToday ? { dateBeforeToday: { value: control.value } } : null;
    };
  }
}
